import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { Typography, Button, useTheme, useMediaQuery } from '@material-ui/core';

import { Page } from 'components';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'white',
    minHeight: '100vh',
    padding: theme.spacing(3),
    paddingTop: '10vh',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center'
  },
  imageContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  },
  image: {
    maxWidth: '100%',
    width: 560,
    // maxHeight: 300,
    height: 'auto'
  },
  buttonContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  }
}));

const Error404 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  const [login, setLogin] = useState();
  useEffect(() => {
    if (localStorage) {
      let userLoginInfo = localStorage.userLoginInfo;
      if (userLoginInfo) {
        userLoginInfo = JSON.parse(userLoginInfo);
        if (userLoginInfo.loggedIn) {
          setLogin(true);
        }
      } else {
        setLogin(false);
      }
    }
  }, [localStorage]);
  return (
    <Page className={classes.root} title="Error 404">
      <Typography align="center" variant={mobileDevice ? 'h4' : 'h1'}>
        404: صفحه مورد نظر اینجا نیست
      </Typography>
      <Typography align="center" variant="subtitle2">
        شما مسیر اشتباهی را وارد کرده اید و یا به اشتباه وارد اینجا شده
        اید.هرکجا هستید از طریق منو راه خود را پیدا کنید
      </Typography>
      <div className={classes.imageContainer}>
        <img
          alt="Under development"
          className={classes.image}
          src="/images/404/404.jpg"
        />
      </div>
      <div className={classes.buttonContainer}>
        <Button
          color="primary"
          component={RouterLink}
          to={login !== undefined && login === false ? '/' : '/myholoopanel/dashboard'}
          variant="outlined">
          بازگشت به صفحه اصلی
        </Button>
      </div>
    </Page>
  );
};

export default Error404;
